import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import Image from '@jetshop/ui/Image';
import { theme } from '../Theme';
import { useIntl } from '@jetshop/intl';
import { useQuery } from 'react-apollo';
import Products from './Products.gql';
// import { useBase64 } from '../../hooks/useBase64';
import ProductLink from '@jetshop/ui/ProductLink';

const FamilyMembersWrapper = styled('div')`
  width: 100%;
  margin-bottom: 40px;

  label {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #333333;
  }
`;

const FamilyMembersItemsWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;

  > * {
    width: fit-content;
    margin-bottom: 13px;
  }

  .family-member-item {
    position: relative;
    width: 50px;
    margin-right: 13px;
    .member-image-wrapper {
      background: ${theme.colors.lightgrey};

      &.current {
        outline: 2px solid ${theme.colors.gold};
      }
      img {
        mix-blend-mode: darken;
      }
    }

    &:hover {
      .item-text {
        opacity: 1;
        visibility: visible;
      }
    }

    .item-text {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      padding: 5px 10px 2px 10px;
      background: ${theme.colors.gold};
      color: #fff;
      font-size: 11px;
      white-space: nowrap;
      margin-top: 10px;

      opacity: 0;
      visibility: hidden;
      transition: all, 0.2s ease;
      &:before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
`;

const GiftCardSelectWrapper = styled('div')`
  margin-top: 10px;
  margin-bottom: 20px;

  h4 {
    font-size: 14px;
  }
  p {
    margin-top: 6px;
    font-size: 14px;
    line-height: 140%;
  }

  .giftcard-buttons {
    display: flex;
    margin-top: 20px;
    button {
      height: 40px;
      margin-right: 10px;
      font-size: 14px;
      color: #333;
      background-color: #f7f7f7;
      font-weight: 500;

      &.selected {
        background-color: #333;
        color: #fff;
      }
    }
  }
`;

export const FamilyMembers = ({
  giftCard,
  articleNumbers,
  current,
  title,
  customFieldKey,
  setSelectedProduct,
  variant
}) => {
  const { data } = useQuery(Products, {
    variables: {
      articles: articleNumbers
    },
    errorPolicy: 'ignore'
  });

  const translate = useIntl();
  const titleText = translate(title);

  const colorType = current?.customFields?.filter(
    customField => customField?.key === 'farge'
  )[0]?.stringValue;

  return (
    <FamilyMembersWrapper className="family-members-wrapper">
      {giftCard ? (
        <GiftCardSelectWrapper>
          <h4>Type av gavekort</h4>
          <p>
            Velg hvordan du vil at vi skal levere gavekortet ditt. Enten som et
            fysisk gavekort eller digitalt til din e-post eller mobiltelefon.
          </p>
        </GiftCardSelectWrapper>
      ) : (
        <label>
          {titleText}: {colorType}
        </label>
      )}

      <FamilyMembersItemsWrapper>
        {data?.products?.map((product, index) => {
          return (
            <div key={'family-member-' + index}>
              <FamilyMemberItem
                giftCard={giftCard}
                product={product}
                index={index}
                customFieldKey={customFieldKey}
                setSelectedProduct={setSelectedProduct}
                current={current}
                variant={variant}
              />
            </div>
          );
        })}
      </FamilyMembersItemsWrapper>
    </FamilyMembersWrapper>
  );
};

const FamilyMemberItem = ({
  giftCard,
  product,
  index,
  setSelectedProduct,
  variant,
  current
}) => {
  const imageAspect = '1:1';
  const imageSizes = [1 / 2, 1 / 2, 1 / 3, 1 / 4];

  // const variantValue = variant?.values?.[0];
  // const { encodedText } = useBase64(variantValue ?? '');

  return (
    <ProductLink product={product}>
      <div className="family-member-item">
        <div
          className={cx(
            'member-image-wrapper',
            current?.articleNumber === product?.articleNumber && 'current'
          )}
        >
          <Image
            src={product?.images?.[0]?.url}
            size={imageSizes}
            aspect={imageAspect}
          />
        </div>
        <div className="item-text">
          {giftCard
            ? product?.name
            : product?.customFields?.filter(
                customField => customField?.key === 'farge'
              )[0]?.stringValue}
        </div>
      </div>
    </ProductLink>
  );
};
